__turbopack_context__.v({
  "container": "styles-module__oa16TG__container",
  "imageWrapper": "styles-module__oa16TG__imageWrapper",
  "list": "styles-module__oa16TG__list",
  "listItem": "styles-module__oa16TG__listItem",
  "protectionLink": "styles-module__oa16TG__protectionLink",
  "section": "styles-module__oa16TG__section",
  "sectionsWrapper": "styles-module__oa16TG__sectionsWrapper",
  "subheading": "styles-module__oa16TG__subheading",
  "textWrapper": "styles-module__oa16TG__textWrapper",
});
